import moment from 'moment';

import Http from '../../api/http';
import Crud, { CARTS, CLIPS } from '../../api/crud';

import {
   AUTH_DISCONNECTED,
   ADDED_TO_CART,
   CART_LOADING,
   CART_LOADED,
   REMOVED_CART,
   REMOVED_FROM_CART,
   REFRESH_CART,
   CHANGED_CART_PAGE,
   SHOW_CLEARED,
   CART_SHARED,
   CART_UNSHARED
} from '../mutation-types';

import {
   ADD_TO_CART,
   CART_LOAD,
   CART_LOAD_BY_ID,
   REMOVE_CART,
   REMOVE_FROM_CART,
   CHECKOUT_CART,
   SHOW_SUCCESS_NOTIFICATION,
   CHANGE_CART_PAGE
} from '../actions';

import each from 'lodash/each';
import flow from 'lodash/flow';
import flatten from 'lodash/flatten';
import size from 'lodash/size';
import find from 'lodash/find';
import extend from 'lodash/extend';
import without from 'lodash/without';
import assign from 'lodash/assign';

import map from 'lodash/fp/map';

const OLD_DATE = '2000-01-01T01:01:01';

const api = (function _detectAPI() {
   // if (process.env.NODE_ENV !== 'production') {
   //    const Mock = require('../../mocks/carts').default;
   //    return new Mock();
   // }
   return new Crud(CARTS);
})();

const clipAPI = (function _detectAPI() {
   // if (process.env.NODE_ENV !== 'production') {
   //    const Mock = require('../../mocks/clips').default;
   //    return new Mock();
   // }
   return new Crud(CLIPS);
})();

const counter = flow(map('clipIds'), flatten, size);

import { CARTS_PAGE_SIZE as PAGE_SIZE } from '../../config';


const DEFAULT_STATE = {
   loading: false,
   carts: [],
   page: 0
};

const getters = {
   isCartsLoaded: state => !state.loading,
   getCartCount: state => counter(state.carts.filter(c => c.status === 'new')),
   getActiveCartList: state => state.carts.filter(c => c.status === 'new'),
   getAllCartList: state => state.carts,
   isProcessingCart: state => state.carts.some(c => c.status !== 'new' && c.status !== 'ready'),

   getCartPageCount: state => Math.ceil(state.carts.length / PAGE_SIZE) - 1,
   getCurrentCartPage: state => state.page,
   getCartsForCurrentPage: state => state.carts.slice(state.page * PAGE_SIZE, state.page * PAGE_SIZE + PAGE_SIZE)
};

const actions = {
   async [CART_LOAD]({ commit }) {
      commit(CART_LOADING);
      commit(CART_LOADED, await api.load());
   },
   async [CART_LOAD_BY_ID]({ commit }, cartId) {
      commit(CART_LOADING);
      var cart = await api.get(cartId);
      commit(CART_LOADED, cart);
   },
   async [ADD_TO_CART]({ commit, dispatch, getters }, { cart, clip }) {
      // commit(CART_UPLOADING_CLIP, videoId);
      if (!cart.id) {
         assign(cart, await api.save(cart));
      }

      if (!clip.id) {
         assign(clip, await clipAPI.save(clip));
      }

      if (!cart.userName) {
         cart.userName = getters.getCurrentUser.userName;
      }
      if (!cart.participants) {
         cart.participants = [];
      }

      const language = getters.language;

      await Http.post(`${CARTS.makePath()}/${cart.id}/clips/${clip.id}`);
      commit(ADDED_TO_CART, { cart, clip, language });
   },
   async [REMOVE_FROM_CART]({ commit, state, getters }, { cartId, clipId, language }) {
      const id = `${cartId}/clips/${clipId}`;
      await api.remove(id, { language });
      commit(REMOVED_FROM_CART, { cartId, clipId });
   },
   async [REMOVE_CART]({ commit, getters }, cart) {
      await api.remove(cart);
      commit(REMOVE_CART, cart);
      if (getters.getCurrentCartPage > getters.getCartPageCount) {
         commit(CHANGED_CART_PAGE, getters.getCartPageCount);
      }
   },
   async [CHECKOUT_CART]({ commit, dispatch, rootGetters }, cart) {
      const resp = await Http.post(`${CARTS.makePath()}/${cart.id}/checkout`, cart);
      const msg = rootGetters.l10n['cart.processed'];
      dispatch(SHOW_SUCCESS_NOTIFICATION, msg);
      commit(REFRESH_CART, { ...cart, ...resp });
   },
   [CHANGE_CART_PAGE]({ commit }, page) {
      commit(CHANGED_CART_PAGE, page);
   }
};


const mutations = {
   [ADDED_TO_CART](state, { cart, clip, language }) {
      cart.clipIds.push(+clip.id);
      cart.clipsLanguages.push(language);
      const stored = find(state.carts, { id: cart.id });
      if (stored) {
         extend(stored, cart);
      } else {
         state.carts.unshift(cart);
      }
   },
   [REFRESH_CART](state, cart) {
      state.carts = state.carts.map(c => {
         if (c.id === cart.id) {
            c.updatedDate = c.updatedDate || OLD_DATE;
            const c1 = { ...c, ...cart };
            if (moment.utc(c.updatedDate).isSameOrBefore(moment.utc(c1.updatedDate))) {
               return c1;
            }
         }
         return c;
      });
   },
   [REMOVED_CART](state, cart) {
      state.carts = without(state.carts, cart);
   },
   [REMOVED_FROM_CART](state, { cartId, clipId }) {
      clipId = +clipId;
      const cart = find(state.carts, { id: cartId });
      if (cart) {
         const idx = cart.clipIds.indexOf(clipId);
         cart.clipIds.splice(idx, 1);
         cart.clipsLanguages.splice(idx, 1);
      }
   },
   [CART_LOADING](state) {
      state.loading = true;
   },
   [CART_LOADED](state, data) {
      if (data instanceof Array) {
         state.carts = data;
      } else {
         for (var i = 0; i < state.carts.length; i++) {
            if (state.carts[i].id === data.id) {
               state.carts.splice(i, 1, data);
            }
         }
      }
      state.loading = false;
   },
   [CHANGED_CART_PAGE](state, page) {
      state.page = page;
   },
   [SHOW_CLEARED](state) {
      state.carts = [];
      state.loading = false;
      state.page = 0;
   },
   [CART_SHARED](state, { id, participants }) {
      var cart;
      for (var i = 0; i < state.carts.length; i++) {
         if (state.carts[i].id === id) {
            cart = state.carts[i];
            break;
         }
      }
      for (var i = 0; i < participants.length; i++) {
         var index = cart.participants.indexOf(participants[i]);
         if (index === -1) {
            cart.participants.push(participants[i]);
         }
      }
   },
   [CART_UNSHARED](state, { id, participants }) {
      var cart;
      for (var i = 0; i < state.carts.length; i++) {
         if (state.carts[i].id === id) {
            cart = state.carts[i];
            break;
         }
      }
      for (var i = 0; i < participants.length; i++) {
         var index = cart.participants.indexOf(participants[i]);
         if (index > -1) {
            cart.participants.splice(index, 1);
         }
      }
   },

   [AUTH_DISCONNECTED](state) {
      each(DEFAULT_STATE, (val, key) => {
         state[key] = val;
      });
   }
};

export default {
   state: { ...DEFAULT_STATE },
   getters,
   actions,
   mutations
};
